import React, { Component } from 'react'
import { Popup, Radio } from 'semantic-ui-react'
import markerSrc from "../img/marker.svg";
import lettersSrc from "../img/letters.svg";

export default class DistanceRadio extends Component {
  state = { isDistance: true }


  handleChange = (b) => {
    this.setState({ isDistance:b });
    this.props.onSortByDistance(this.state.isDistance)
  }

  render() {
    return (
      <div id="distance-radio">

        <div id="radio-images">
          <Popup trigger={<img src={markerSrc} onClick={()=>this.handleChange(true)} />} content='Km de tí' />
          <Popup trigger={<img src={lettersSrc} onClick={()=>this.handleChange(false)} />}  content='Orden Alfabetico' />
        </div>
        <Radio
          slider
          name='radioGroup'
          value='distance'
          checked={!this.state.isDistance}
          onChange={()=>this.handleChange(!this.state.isDistance)}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/itemslist/DistanceRadio.js